"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../styles");

var _designLanguage = require("@doordash/design-language");

var _CloseButton = _interopRequireDefault(require("./CloseButton"));

var _constants = require("../constants");

var _HeaderText = _interopRequireDefault(require("./HeaderText"));

var _ModalHeaderImage = _interopRequireDefault(require("./ModalHeaderImage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DefaultContentHeader = function DefaultContentHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      closeButtonSide = _ref.closeButtonSide,
      headerAlignment = _ref.headerAlignment,
      headerImage = _ref.headerImage,
      hasCloseButton = _ref.hasCloseButton,
      hasContent = _ref.hasContent,
      hasPadding = _ref.hasPadding,
      modalPadding = _ref.modalPadding,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      subtitleSize = _ref.subtitleSize,
      title = _ref.title,
      titleSize = _ref.titleSize,
      useHairlineDividers = _ref.useHairlineDividers;
  var displayCloseButton = !headerImage && hasCloseButton;

  if (closeButtonSide === _constants.CloseButtonSides.Trailing) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, headerImage && /*#__PURE__*/_react["default"].createElement(_ModalHeaderImage["default"], {
      headerImage: headerImage
    }), /*#__PURE__*/_react["default"].createElement(_styles.HeaderInlineTitleContainer, {
      hasCloseButton: displayCloseButton,
      hasPadding: hasPadding,
      isCenterAligned: headerAlignment === _designLanguage.Text.TextAlignments.Center,
      modalPadding: modalPadding,
      hasHeaderImage: !!headerImage
    }, /*#__PURE__*/_react["default"].createElement(_styles.HeaderInlineTitleTextContainer, {
      size: hasPadding ? _designLanguage.StackChildren.Sizes.XxSmall : _designLanguage.StackChildren.Sizes.None
    }, /*#__PURE__*/_react["default"].createElement(_HeaderText["default"], {
      headerAlignment: headerAlignment,
      title: title,
      subtitle: subtitle,
      titleSize: titleSize,
      subtitleSize: subtitleSize,
      isInlineTitle: true
    })), displayCloseButton && /*#__PURE__*/_react["default"].createElement(_styles.ModalInlineCloseButtonContainer, {
      modalPadding: modalPadding
    }, /*#__PURE__*/_react["default"].createElement(_CloseButton["default"], {
      closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
      onClose: onClose
    }))));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayCloseButton && /*#__PURE__*/_react["default"].createElement(_styles.ModalCloseButtonContainer, {
    closeButtonSide: closeButtonSide,
    modalPadding: modalPadding
  }, /*#__PURE__*/_react["default"].createElement(_CloseButton["default"], {
    closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
    onClose: onClose
  })), headerImage && /*#__PURE__*/_react["default"].createElement(_ModalHeaderImage["default"], {
    headerImage: headerImage
  }), /*#__PURE__*/_react["default"].createElement(_styles.HeaderTextContainer, {
    hasCloseButton: hasCloseButton,
    hasContent: hasContent,
    hasHeaderImage: !!headerImage,
    hasContentPadding: hasPadding,
    modalPadding: hasPadding ? modalPadding : 0,
    useHairlineDividers: useHairlineDividers
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.StackChildren, {
    size: hasPadding ? _designLanguage.StackChildren.Sizes.XxSmall : _designLanguage.StackChildren.Sizes.None
  }, /*#__PURE__*/_react["default"].createElement(_HeaderText["default"], {
    headerAlignment: headerAlignment,
    title: title,
    subtitle: subtitle,
    titleSize: titleSize,
    subtitleSize: subtitleSize,
    isInlineTitle: false
  }))));
};

DefaultContentHeader.propTypes = {
  closeButtonAccessibilityLabel: _propTypes["default"].string,
  closeButtonSide: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  headerAlignment: _propTypes["default"].oneOf([_designLanguage.Text.TextAlignments.Left, _designLanguage.Text.TextAlignments.Center]).isRequired,
  headerImage: _propTypes["default"].node,
  title: _propTypes["default"].node,
  subtitle: _propTypes["default"].string,
  titleSize: _propTypes["default"].number,
  subtitleSize: _propTypes["default"].number,
  hasCloseButton: _propTypes["default"].bool.isRequired,
  hasContent: _propTypes["default"].bool.isRequired,
  hasPadding: _propTypes["default"].bool,
  titleId: _propTypes["default"].string.isRequired,
  subtitleId: _propTypes["default"].string,
  modalPadding: _propTypes["default"].number,
  useHairlineDividers: _propTypes["default"].bool
};
var _default = DefaultContentHeader;
exports["default"] = _default;